<!-- Hiba bejelentése: egy példány a vázban, az SzIssueReportDialogService nyitja (Hibajelzés oldal, felső sáv „?” menü) -->
<mx-dialog [visible]="visible" (visibleChange)="$event ? null : close()" header="Hiba bejelentése" [style]="{ width: '720px' }" styleClass="sz-ir-dialog" [closable]="!busy" [dismissableMask]="false">
  <div content>
    <div class="sz-ir-form">
      <div class="sz-ir-note">Írd le, mi történt és mit vártál helyette; a képernyőkép sokat segít. A bejelentés állapotáról a harang alatt értesítünk.</div>

      <div class="sz-ir-field">
        <label class="sz-label">Terület</label>
        <sz-pills [options]="areaOptions" [value]="area" (valueChange)="setArea($event)"></sz-pills>
      </div>

      <div class="sz-ir-field" *ngIf="area === IssueReportArea.Portal; else appPage">
        <label class="sz-label">Melyik oldalon?</label>
        <p-dropdown
          [options]="pageOptions"
          [(ngModel)]="page"
          optionLabel="label"
          optionValue="value"
          [editable]="true"
          [filter]="true"
          filterBy="label"
          appendTo="body"
          placeholder="Válassz a menüből, vagy írd be"
          styleClass="w-full sz-ir-page"
        ></p-dropdown>
        <span class="sz-hint">A menü oldalai; ha máshol történt (pl. egy részletoldalon), írd be szabadon.</span>
      </div>
      <ng-template #appPage>
        <div class="sz-ir-field">
          <label class="sz-label">Melyik képernyőn?</label>
          <input pInputText class="w-full" [(ngModel)]="page" [maxlength]="200" placeholder="Pl. Beváltás, Oktatás kvíz, Pontjaim" />
        </div>
      </ng-template>

      <div class="sz-ir-field">
        <label class="sz-label">Cím <span class="sz-ir-req">*</span></label>
        <input pInputText class="w-full" [(ngModel)]="title" [maxlength]="titleMax" name="title" placeholder="Röviden: mi a hiba?" [class.ng-invalid]="submitted && titleError" [class.ng-dirty]="submitted && titleError" />
        <div class="sz-ir-row">
          <small class="sz-ir-error" *ngIf="submitted && titleError">{{ titleError }}</small>
          <span class="sz-hint sz-ir-count">{{ title.length }} / {{ titleMax }}</span>
        </div>
      </div>

      <div class="sz-ir-field">
        <label class="sz-label">Leírás <span class="sz-ir-req">*</span></label>
        <textarea pInputTextarea class="w-full" [(ngModel)]="description" [maxlength]="descriptionMax" name="description" rows="6" placeholder="Mit csináltál, mit vártál, mi történt? Ha van, írd ide a hibaüzenetet is." [class.ng-invalid]="submitted && descriptionError" [class.ng-dirty]="submitted && descriptionError"></textarea>
        <div class="sz-ir-row">
          <small class="sz-ir-error" *ngIf="submitted && descriptionError">{{ descriptionError }}</small>
          <span class="sz-hint sz-ir-count">{{ description.length }} / {{ descriptionMax }}</span>
        </div>
      </div>

      <div class="sz-ir-field">
        <label class="sz-label">Súlyosság</label>
        <p-dropdown [options]="severityOptions" [(ngModel)]="severity" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full sz-ir-severity">
          <ng-template let-o pTemplate="item"><span class="sz-ir-sev">{{ o.label }}<span class="sz-hint">{{ o.hint }}</span></span></ng-template>
        </p-dropdown>
      </div>

      <div class="sz-ir-field">
        <label class="sz-label">Csatolmány <span class="sz-hint">(kép vagy PDF, legfeljebb {{ maxFiles }} fájl, 5 MB)</span></label>
        <div class="sz-ir-files">
          <div class="sz-ir-file" *ngFor="let a of attachments; trackBy: trackAttachment">
            <img *ngIf="a.previewUrl" [src]="a.previewUrl" [alt]="a.file.name" />
            <span class="sz-ir-file-icon" *ngIf="!a.previewUrl"><span class="sz-icon sz-icon-24">picture_as_pdf</span></span>
            <span class="sz-ir-file-name" [title]="a.file.name">{{ a.file.name }}<span class="sz-hint">{{ mb(a.file.size) }} MB</span></span>
            <button type="button" class="sz-ir-file-remove" (click)="removeAttachment(a)" title="Eltávolítás" [disabled]="busy"><span class="sz-icon sz-icon-18">close</span></button>
          </div>
          <label class="sz-ir-add" *ngIf="attachments.length < maxFiles" [class.sz-ir-add-disabled]="busy">
            <span class="sz-icon sz-icon-20">add_photo_alternate</span>Fájl hozzáadása
            <input type="file" [accept]="accept" multiple (change)="pickFiles($any($event.target))" [disabled]="busy" />
          </label>
        </div>
      </div>
    </div>
  </div>
  <div footer-right>
    <p-button icon="fa fa-times fa-fw" (onClick)="close()" [label]="'button:Cancel' | i18next" styleClass="p-button-text" [disabled]="busy"></p-button>
    <p-button icon="fa fa-paper-plane fa-fw" (onClick)="submit()" label="Beküldés" [disabled]="busy" [loading]="busy"></p-button>
  </div>
</mx-dialog>
